import React from 'react';
import { Button } from '../ui/button';
import { MessageSquare } from 'lucide-react';
import { useContactContext } from '../../contexts/ContactContext';

interface SendQuestionButtonProps {
  authorId: string;
  source: 'Timeline' | 'Meetings' | 'Marketplace' | 'Financial Reports';
  className?: string;
}

const SendQuestionButton: React.FC<SendQuestionButtonProps> = ({ 
  authorId, 
  source,
  className = '' 
}) => {
  const { contactUser } = useContactContext();

  const handleSendQuestion = () => {
    if (contactUser) {
      contactUser.openContactModal(authorId, source);
    }
  };

  if (!contactUser) {
    return null;
  }

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleSendQuestion}
      className={`flex items-center gap-2 border-green-500 text-green-700 hover:text-green-800 hover:border-green-600 bg-white h-10 text-sm whitespace-nowrap ${className}`}
    >
      <MessageSquare className="h-4 w-4" />
      Send Question
    </Button>
  );
};

export default SendQuestionButton; 